<!-- 借據管理_編輯擔保品
     擔保品基本資料 -->
<template>
    <div class="row" :class="{'ml10':id !=='new'}">
        <div class="col-12">
            <el-tabs type="border-card">
                <el-tab-pane label="基本資料">
                    <ListForm
                        api="coopLoanIouCollateral"
                        :id="id"
                        labelPosition="top"
                        :rules="rules"
                        :recordToEdit="recordToEdit"
                        :formType="formType"
                        ref="listForm"
                    >
                        <div slot="footer">
                            <el-button
                                type="primary"
                                :loading="isSaving"
                                @click="handleSubmit"
                                v-if="id =='new'"
                            >儲存</el-button>
                            <el-button
                                @click="back"
                            >取消</el-button>
                        </div>
                    </ListForm>
                </el-tab-pane>
                <el-tab-pane v-if="this.$route.params.subId !== 'new'" label="附件">
                    <el-button type="primary" plain @click="openDialog()">上傳其他文件</el-button>
                    <table class="table table-bordered mb-0 mt10">
                        <thead class="grey lighten-4">
                            <tr>
                                <th></th>
                                <th style="width: 220px;"></th>
                                <th>文件名稱</th>
                                <th>檔案名稱</th>

                                <th>最後修改</th>
                                <th>最後修改人員</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item) in fileArray" :key="item.fileId">
                                <td>{{item.fileId}}</td>
                                <td>
                                    <el-button
                                        type="primary"
                                        size="small"
                                        @click="openDialog(item)"
                                    >修改</el-button>
                                    <el-button
                                        type="success"
                                        size="small"
                                        @click="downLoadFile(item.fileId)"
                                    >下載</el-button>
                                    <el-button
                                        type="danger"
                                        size="small"
                                        @click="removeFile(item.fileId)"
                                    >刪除</el-button>
                                </td>
                                <td>{{item.fileDesc}}</td>
                                <td>{{item.fileName}}</td>
                                <td>{{item.lastUploadTime}}</td>
                                <td>{{item.lastUploadUserName}}</td>
                            </tr>
                        </tbody>
                    </table>
                </el-tab-pane>
            </el-tabs>
        </div>
        <!--Modal-->
        <el-dialog title="新增額外文件" :visible.sync="dialogNote" :append-to-body="true">
            <el-form :model="fileEdit">
                <el-form-item label="文件名稱">
                    <el-input type="input" placeholder="請輸入內容" v-model="fileEdit.fileDesc"></el-input>
                </el-form-item>

                <input
                    style="display:none"
                    type="file"
                    id="uploadFile"
                    @change="uploadFile"
                    accept=".pdf"
                />
                <div class="mt10">
                    <el-form-item label="檔案上傳">
                        <el-button size="medium" type="primary" @click="clickUploadBtn">上傳</el-button>
                        <!-- 新增檔案 -->
                        <span class="ml-2" v-if="fileEdit.file">{{ fileEdit.file.name }}</span>
                        <!-- 既有檔案 -->
                        <span class="ml-2" v-else-if="fileEdit.fileName">{{ fileEdit.fileName }}</span>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogNote = false">取消</el-button>
                <el-button type="primary" @click="saveDialogEdit">確定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import ListForm from "@/components/ListForm.vue";
import { API } from "@/assets/config";

export default {
    name: "after_loan_collateral_edit",
    components: {
        ListForm
    },

    data() {
        return {
            dialogNote: false,
            isSaving: false,
            fileArray: [],
            id: this.$route.params.subId,
            recordToEdit: {},
            fileEdit: {},
            formType: [
                {
                    type: "post",
                    key: "coopLoanIouId",
                    value: this.$route.params.id
                },
                {
                    label: "名稱",
                    key: "name",
                    type: "input"
                },
                {
                    label: "標的物",
                    key: "subjectMatter",
                    type: "input"
                },
                {
                    label: "設定順位",
                    key: "setOrder",
                    type: "number"
                },
                {
                    label: "所有權人",
                    key: "ownerName",
                    type: "input"
                },
                {
                    label: "基本資料 ( 地號、建號、車號 )",
                    key: "basicInfo",
                    type: "input"
                },
                {
                    label: "鑑估方式",
                    key: "valuationType",
                    type: "radio",
                    options: [
                        {
                            label: "鑑價小組",
                            value: 1
                        },
                        {
                            label: "委外鑑價",
                            value: 2
                        }
                    ]
                },
                {
                    label: "鑑價金額",
                    key: "valuationAmount",
                    type: "number"
                },
                {
                    label: "設定義務人",
                    key: "setObligor",
                    type: "input"
                },
                {
                    label: "權利人",
                    key: "rightHolder",
                    type: "input"
                },
                {
                    label: "權利價值(最高限額抵押權金額)",
                    key: "rightValue",
                    type: "input"
                }
            ],
            rules: {
                code: [
                    { required: true, message: "請輸入編號", trigger: "blur" }
                ],
                changeDate: [
                    { required: true, message: "請選擇日期", trigger: "change" }
                ]
            }
        };
    },
    created() {
        if (this.id != "new") {
            this.getData();
        }
    },
    methods: {
        /**
         * 儲存新增的擔保品，成功後返回清單
         */
        async handleSubmit() {
            if (this.isSaving) return;
            this.isSaving = true;
            try {
                await this.$refs.listForm.submitForm("recordToEdit");
                this.back()
            } catch (e) {
                this.isSaving = false;
            }
        },
        /**
         * 開啟附件編輯視窗
         * @param {Object} [item] - 既有附件，未帶則為新增
         */
        openDialog(item = undefined) {
            if (item !== undefined) {
                this.fileEdit = item;
            } else {
                this.fileEdit = {};
            }
            this.dialogNote = true;
        },
        /**
         * 刪除指定附件
         * @param {Number} fileId - 附件 id
         */
        removeFile(fileId) {
            let url = API.coopLoanIouCollateral;
            this.$http
                .delete(url, {
                    params: {
                        action: "deleteFile",
                        id: this.id,
                        select: {
                            FieldName: "id",
                            IsAllSelect: false,
                            MemberSelectJson: JSON.stringify([fileId])
                        }
                    }
                })
                .then(response => {
                    this.showAjaxSuccessMsg("remove");
                    this.getData();
                })
                .catch(error => {
                    this.postErrorHandler("remove");
                });
        },
        /**
         * 下載指定附件
         * @param {Number} fileId - 附件 id
         */
        downLoadFile(fileId) {
            let url =
                API.coopLoanIouCollateral +
                `?action=downloadForm&id=${this.id}&fileId=${fileId}`;

            this.mDownloadFile(url);
        },
        /**
         * 暫存使用者選擇的檔案
         * @param {Event} event - file input 的 change 事件
         */
        uploadFile(event) {
            if (event.target.files && event.target.files[0]) {
                this.$set(this.fileEdit, "file", event.target.files[0]);
            }
        },
        /**
         * 送出附件視窗的新增／修改
         */
        saveDialogEdit() {
            let url =
                API.coopLoanIouCollateral +
                `?action=uploadForm&id=${this.id}`;

            const form = new FormData();

            form.append("fileId", this.fileEdit.fileId || 0);
            form.append("fileDesc", this.fileEdit.fileDesc);

            form.append("fileName", this.fileEdit.fileName || "");
            form.append("filePath", this.fileEdit.filePath || "");
            if (this.fileEdit.file !== undefined) {
                form.append("file", this.fileEdit.file);
            }

            let thenCB = json => {
                this.showAjaxSuccessMsg();
                this.dialogNote = false;
                this.getData();
            };
            this.mAxiosPost(url, form, thenCB);
        },
        /**
         * 觸發隱藏的 file input
         */
        clickUploadBtn() {
            let a = document.getElementById("uploadFile");
            a.click();
        },
        /**
         * 取得擔保品資料與附件清單
         */
        getData() {
            const url = API.coopLoanIouCollateral + `?id=${this.id}`;

            const thenCB = json => {
                this.recordToEdit = Object.assign(
                    {},
                    this.recordToEdit,
                    json.resultData.data
                );
                this.id = this.$route.params.subId;
                this.fileArray = json.resultData.data.fileArray;
            };
            this.mAxiosGet(url, thenCB);
        },
        /**
         * 返回擔保品清單
         */
        back() {
            this.$router.push({ name: "after_loan_collateral" });
        }
    }
};
</script>
